<template>
  <div :class="$style.container">
    <img
      v-if="picture"
      :src="picture"
      alt=""
      :class="$style.avatarImage"
    >
    <div
      v-else
      :class="$style.initialsWrapper"
    >
      <div :class="[$style.initialsLabel, {[$style.initialsLabelStyleSmall]: small}]">{{ initials }}</div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      small: {
        type: Boolean,
        default: false
      },
      name: {
        type: String
      },
      picture: {
        type: String
      }
    },
    computed: {
      initials () {
        let first = ''
        let last = ''
        const words = this.name.split(' ').filter(w => w.length > 0)
        if (words.length > 0) { first = words[0][0] }
        if (words.length > 1) { last = words[words.length - 1][0] }
        return (first + last).toLocaleUpperCase()
      }
    }
  }
</script>

<style lang="scss" module>
  @import "~@stylesheets/includes/mixins.scss";

  /**
   * Container
   */
  .container {
    width: 100%;
    height: 100%;
  }

  /**
   * Avatar image
   */
  .avatarImage {
    display: block;
    width: 100%;
    height: 100%;
  }

  /**
   * Initials wrapper
   */
  .initialsWrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    text-align: center;
    background-color: #d8dde6;
  }

  /**
   * Initials Label
   */
  .initialsLabel {
    color: #fff;
    font-size: 16px;
    letter-spacing: .7px;
    text-transform: uppercase;
  }

  .initialsLabelStyleSmall {
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Avatar.vue